export default __webpack_public_path__ + "static/media/geolane.61195c41.png";